import Skeleton from '../../components/Skeleton/Skeleton';

const ViewCreationSkeleton = () => {
    return (
        <div>
            <Skeleton width='100%' height='248px' />
            <div className='ProfileContainerSkeleton'>
                <div className='d-flex f-row aic'>
                    <Skeleton width='32px' height='32px' borderRadius='32px' />
                    <Skeleton width='120px' height='12px' borderRadius='12px' className={"ml-12"} />
                </div>
                <Skeleton width='100%' height='12px' borderRadius='12px' className={"mt-16"} />


            </div>
            <div className='mx-16 mt-16 '>
                <Skeleton width='100%' height='12px' borderRadius='12px' />
                <Skeleton width='100%' height='12px' borderRadius='12px' className={"mt-8"} />
                <Skeleton width='70%' height='12px' borderRadius='12px' className={"mt-8"} />
            </div>
        </div>
    );
}
export default ViewCreationSkeleton;
